import React from 'react'
import {Card} from 'reactstrap'

const card=(props)=>(<Card {...props}/>)

export default card;